// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"ImagePreviewDialog_dialogWrapper__jxbYh","closeBtn":"ImagePreviewDialog_closeBtn__y51x_","image":"ImagePreviewDialog_image__bI5Y0"};